import { gql } from '@apollo/client'
import { PLAN_OBJECTIVE_DETAILS_FRAGMENT } from './queries'

export const PLAN_OBJECTIVE_CREATE_MUTATION = gql`
  mutation PLAN_OBJECTIVE_CREATE_MUTATION($input: PlanObjectiveCreateInput!) {
    planObjectiveCreate(input: $input) {
      ok
      data {
        id
        __typename

        planTypeId
        description
        createdAt
        treePosition
      }
    }
  }
`

export const PLAN_OBJECTIVE_UPDATE_MUTATION = gql`
  mutation PLAN_OBJECTIVE_UPDATE_MUTATION($id: ID!, $input: PlanObjectiveUpdateInput!) {
    planObjectiveUpdate(id: $id, input: $input) {
      ok
      data {
        ...PLAN_OBJECTIVE_DETAILS
      }
    }
  }
  ${PLAN_OBJECTIVE_DETAILS_FRAGMENT}
`

export const PLAN_OBJECTIVE_DELETE_MUTATION = gql`
  mutation PLAN_OBJECTIVE_DELETE_MUTATION($id: ID!) {
    planObjectiveDelete(id: $id) {
      ok
    }
  }
`
